module.exports = __webpack_public_path__ + "img/spbu3.bf99f697.png";